// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "bar-xinglet-843b477e/chunk-" + {"593": "2d757f1ad74977b3","814": "e1d8f5fad8b08f1e","855": "b6d8ce816f502a58",}[chunkId] + ".js"
}